import ConnectSuppliersPage from './ConnectSuppliersPage'

export default ConnectSuppliersPage
